const projectElements = [
    {
        id: 1,
        title: "Instagram",
        a: "https://github.com/devptl04/Instagram",
        icon: "fab fa-instagram",
        description: "This full stack project mirrors the core functionalites of Instagram. This project offers a seamless user experience for photo sharing, including features such as user authentication, real-time posts, likes, and comments.",
        tech: ["Firebase", "React", "JavaScript", "Chakra UI"],
    },
    {
        id: 2,
        title: "AWS Deep Racer",
        a: "https://github.com/devptl04/AWS-Deep-Racer",
        icon: "fa fa-car",
        description: "This project leverages the exciting realm of machine learning and autonomous vehicles through AWS DeepRacer, a 1/18th scale race car which I trained to drive itself using reinforcement learning.",
        tech: ["Python", "AWS Cloud", "Machine Learning"],
    },
    {
        id: 3,
        title: "Premier League ML Predictor",
        a: "https://github.com/devptl04/Premier-League-ML-Predictor",
        icon: "fas fa-futbol",
        description: "Utilized 4 years worth of data via web scraping to create a ML algorithm that predicts Premier League matches, leveraging logistic regression and random forest models optimized through hyperparameter tuning and cross-validation.",
        tech: ["Python", "Beautiful Soup", "Pandas", "Skit-learn"],
    },
    {
        id: 4,
        title: "Classmate",
        a: "https://classmate.lol/",
        icon: "fas fa-university",
        description: "This full stack web application that I helped develop/enhance streamlines the college course scheduling process. This project includes features such as user authentication, real-time scheduling updates, and user feedback integration. Current user base: 25,000+",
        tech: ["HTML", "CSS", "React", "Tailwind"],
    },
    {
        id: 5,
        title: "Custom Chrome Extension",
        a: "https://github.com/devptl04/Chrome-Extension",
        icon: "fa fa-window-restore",
        description: "When clicked on, it suggest activites and events to attend near you",
        tech: ["Javascript", "HTML"],
    },
    {
        id: 6,
        title: "Personal Website",
        a: "https://github.com/devptl04/Personal-Portfolio",
        icon: "fa fa-mouse-pointer",
        description: "I built this website by scratch with inspiration for a multitude of online portfolios, adding my own flavor to them",
        tech: ["React", "HTML", "Tailwind", "CSS"],
    },
    {
        id: 7,
        title: "Annapurna Website",
        a: "https://github.com/devptl04/Catering-Website/",
        icon: "fa fa-globe",
        description: "Created a fully responsive website for a local catering company",
        tech: ["HTML", "CSS", "React", "Tailwind"],
    }
];

export default projectElements